const shaderList = [
  ['addVectorsFrag', `addVectors.frag`],
  ['brdfFrag', `brdf.frag`],
  ['brushViewerFrag', `brushViewer.frag`],
  ['calculateColorFrag', `calculateColor.frag`],
  ['calculateColorFromReflectanceFrag', `calculateColorFromReflectance.frag`],
  ['divergenceFrag', `divergence.frag`],
  ['fullscreenVert', `fullscreen.vert`],
  ['jacobiFrag', `jacobi.frag`],
  ['manageAlphaFrag', `manageAlpha.frag`],
  ['outputFrag', `output.frag`],
  ['setOperationFrag', `setOperation.frag`],
  ['splatFrag', `splat.frag`],
  ['subtractFrag', `subtract.frag`],
  ['surfaceFrag', `surface.frag`],
  ['updateReflectanceFrag', `updateReflectance.frag`],

  ['singleBendingConstraintFrag', `singleBendingConstraint.frag`],
  ['singleBrushViewerVert', `singleBrushViewer.vert`],
  ['singleDistanceConstraintFrag', `singleDistanceConstraint.frag`],
  ['singlePlaneConstraintFrag', `singlePlaneConstraint.frag`],
  ['singleProjectFrag', `singleProject.frag`],
  ['singleSetBristlesFrag', `singleSetBristles.frag`],
  ['singleSplatVert', `singleSplat.vert`],
  ['singleUpdateVelocityFrag', `singleUpdateVelocity.frag`],

  ['tripleBendingConstraintFrag', `tripleBendingConstraint.frag`],
  ['tripleBrushViewerVert', `tripleBrushViewer.vert`],
  ['tripleDistanceConstraintFrag', `tripleDistanceConstraint.frag`],
  ['triplePlaneConstraintFrag', `triplePlaneConstraint.frag`],
  ['tripleProjectFrag', `tripleProject.frag`],
  ['tripleSetBristlesFrag', `tripleSetBristles.frag`],
  ['tripleSplatVert', `tripleSplat.vert`],
  ['tripleUpdateVelocityFrag', `tripleUpdateVelocity.frag`],

  ['doubleBendingConstraintFrag', `doubleBendingConstraint.frag`],
  ['doubleBrushViewerVert', `doubleBrushViewer.vert`],
  ['doubleDistanceConstraintFrag', `doubleDistanceConstraint.frag`],
  ['doublePlaneConstraintFrag', `doublePlaneConstraint.frag`],
  ['doubleProjectFrag', `doubleProject.frag`],
  ['doubleSetBristlesFrag', `doubleSetBristles.frag`],
  ['doubleSplatVert', `doubleSplat.vert`],
  ['doubleUpdateVelocityFrag', `doubleUpdateVelocity.frag`],
];

export default shaderList;
